import React from "react";
import { Route, Navigate } from "react-router-dom";
import Dashboard from "../../feature-module/dashboard/Dashboard";
import ChartsDashboard from "../../feature-module/dashboard/ChartsDashboard";
import Chamados from "../../feature-module/chamado/chamados";

const routes = all_routes;

import Profile from "../../feature-module/pages/profile";
import Signin from "../../feature-module/pages/login/signin";
import Register from "../../feature-module/pages/register/register";
import Forgotpassword from "../../feature-module/pages/forgotpassword/forgotpassword";
import Resetpassword from "../../feature-module/pages/resetpassword/resetpassword";
import EmailVerification from "../../feature-module/pages/emailverification/emailverification";
import Twostepverification from "../../feature-module/pages/twostepverification/twostepverification";
import Error404 from "../../feature-module/pages/errorpages/error404";
import Error500 from "../../feature-module/pages/errorpages/error500";
import Undermaintainence from "../../feature-module/pages/undermaintainence";
import Users from "../../feature-module/usermanagement/users";
import { all_routes } from "./all_routes";
import UsuarioAcessoRelatorioPage from "../../feature-module/usuario-acesso-relatorio/pages/UsuarioAcessoRelatorioPage";
import ConfiguracaoGrupoAcesso from "../../feature-module/usermanagement/ConfiguracaoGrupoAcesso";
import UnificacaoCadastros from "../../feature-module/unificacao-de-cadastros/UnificacaoCadastros";
import RoleRoute from "./RoleRoute";
import Atualizacoes from "../../feature-module/pages/atualizacoes/Atualizacoes";
import ImportacaoOrganograma from "../../feature-module/pages/importacaoorganograma/ImportacaoOrganograma";
import ConvocacaoRastreamento from "../../feature-module/convocacao/pages/ConvocacaoRastreamento";
import ConvocacaoSeguimento from "../../feature-module/convocacao/pages/ConvocacaoSeguimento";
import ConvocacaoMunicipioGuard from "../../feature-module/convocacao/components/ConvocacaoMunicipioGuard";

export const publicRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: "home",
    element: <Dashboard />,
    route: Route,
  },
  {
    id: 2,
    path: routes.configuracaogrupodeacesso,
    element: (
      <RoleRoute allowedTypes={[2, 3, 5]}>
        <ConfiguracaoGrupoAcesso />
      </RoleRoute>
    ),
  },
  {
    id: 3,
    path: routes.atualizacoes,
    name: "atualizacoes",
    element: <Atualizacoes />,
    route: Route,
  },

  {
    id: 4,
    path: routes.importacaoorganograma,
    name: "importacaoorganograma",
    element: <ImportacaoOrganograma />,
    route: Route,
  },
  {
    id: 5,
    path: routes.profile,
    name: "profile",
    element: <Profile />,
    route: Route,
  },
  {
    id: 6,
    path: routes.users,
    element: (
      <RoleRoute allowedTypes={[2, 3, 5]}>
        <Users />
      </RoleRoute>
    ),
  },

  {
    id: 7,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 8,
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
  },
  {
    id: 9,
    path: routes.chamados,
    name: "chamados",
    element: (
      <RoleRoute allowedTypes={[5]}>
        <Chamados />{" "}
      </RoleRoute>
    ),
    route: Route,
  },
  {
    id: 10,
    path: routes.chartsdashboard,
    name: "charts",
    element: (
      <RoleRoute allowedTypes={[3]}>
        <ChartsDashboard />
      </RoleRoute>
    ),
    route: Route,
  },
  {
    id: 11,
    path: routes.usuarioacessorelatorio,
    element: (
      <RoleRoute allowedTypes={[2, 3, 5]}>
        <UsuarioAcessoRelatorioPage />
      </RoleRoute>
    ),
  },
  {
    id: 12,
    path: routes.unificacaodecadastros,
    name: "unificacaodecadastros",
    element: <UnificacaoCadastros />,
    route: Route,
  },
  {
    id: 13,
    path: routes.convocacaorastreamento,
    name: "convocacaorastreamento",
    element: (
      <ConvocacaoMunicipioGuard>
        <ConvocacaoRastreamento />
      </ConvocacaoMunicipioGuard>
    ),
    route: Route,
  },
  {
    id: 14,
    path: routes.convocacaoseguimento,
    name: "convocacaoseguimento",
    element: (
      <ConvocacaoMunicipioGuard>
        <ConvocacaoSeguimento />
      </ConvocacaoMunicipioGuard>
    ),
    route: Route,
  },
];
export const posRoutes = [];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 4,
    path: routes.register,
    name: "register",
    element: <Register />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
  {
    id: 9,
    path: routes.resetpassword,
    name: "resetpassword",
    element: <Resetpassword />,
    route: Route,
  },
  {
    id: 12,
    path: routes.emailverification,
    name: "emailverification",
    element: <EmailVerification />,
    route: Route,
  },
  {
    id: 14,
    path: routes.twostepverification,
    name: "twostepverification",
    element: <Twostepverification />,
    route: Route,
  },
  {
    id: 18,
    path: routes.error404,
    name: "error404",
    element: <Error404 />,
    route: Route,
  },
  {
    id: 19,
    path: routes.error500,
    name: "error500",
    element: <Error500 />,
    route: Route,
  },
  {
    id: 21,
    path: routes.undermaintenance,
    name: "undermaintenance",
    element: <Undermaintainence />,
    route: Route,
  },
];
